export type RandomFn = () => number;

/** Mulberry32 — fast seeded PRNG returning values in [0, 1). */
export function createRng(seed: number): RandomFn {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function generateGameSeed(): number {
  return Math.floor(Math.random() * 0x7fffffff);
}

export function randomInt(rng: () => number, max: number): number {
  return Math.floor(rng() * max);
}
